export default __webpack_public_path__ + "static/media/YIP LOGO-01.4c68d45a.png";